import { render, staticRenderFns } from "./data-wraper.vue?vue&type=template&id=4525b142"
import script from "./data-wraper.vue?vue&type=script&lang=ts"
export * from "./data-wraper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports